import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import FieldSet from '../../../../../../components/Modules/FieldSet';
import Selector from '../../../../../../components/Modules/Selector';
import DateFilter from '../../../../../../components/Modules/DateFilter';
import courtsMapper from '../../../courtsMapper';
import './bankruptcy.less';


class Bankruptcy extends Component {
  regionOptions = courtsMapper('bankruptcy', 'Bankruptcy Court')

  dateFormat = date => date.format('MM/DD/YYYY');

  render() {
    const {
      region,
      chapter,
      caseType,
      dateType,
      dateFrom,
      dateTo,
      typeOfDebtor,
      natureOfDebt,
      natureOfBusiness,
      assets,
      caseProperties,
      partyInfo,
      select,
      multiselect,
    } = this.props;

    return (
      <div className="reports-tab-form reports-tab-forms-bankruptcy">
        <FieldSet title="Case Information">
          <div className="row no-padding">
            <Selector
              id="reports-region"
              multi
              clearable={false}
              className="reports-tab-bankruptcy-region-selector"
              options={this.regionOptions}
              title="Region"
              value={region}
              placeholder="Select Region"
              onChange={multiselect.bind(this, 'region')}/>
            <Selector
              multi
              clearable={false}
              className="reports-tab-bankruptcy-chapter-selector"
              options={chapterOptions}
              title="Chapter"
              value={chapter}
              placeholder="Any"
              onChange={multiselect.bind(this, 'chapter')}/>
            <Selector
              multi
              clearable={false}
              className="reports-tab-bankruptcy-case-type-selector"
              options={caseTypeOptions}
              title="Case Type"
              value={caseType}
              placeholder="Any"
              onChange={multiselect.bind(this, 'caseType')}
            />
          </div>
          <div className="row date-selectors">
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-date-type-selector"
              options={dateTypeOptions}
              title="Date Type"
              value={dateType}
              placeholder=""
              onChange={select.bind(this, 'dateType')}/>
            <DateFilter
              from={dateFrom}
              to={dateTo}
              onChangeFrom={select.bind(this, 'dateFrom')}
              onChangeTo={select.bind(this, 'dateTo')}
              className="reports-tab-bankruptcy-date-filter-selector"/>
          </div>
        </FieldSet>
        <FieldSet title="Advanced Filters">
          <div className="row no-padding">
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-type-of-debtor-selector"
              options={typeOfDebtorOptions}
              title="Type of Debtor"
              value={typeOfDebtor}
              placeholder=""
              onChange={select.bind(this, 'typeOfDebtor')}/>
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-nature-of-debt-selector"
              options={natureOfDebtOptions}
              title="Nature of Debt"
              value={natureOfDebt}
              placeholder=""
              onChange={select.bind(this, 'natureOfDebt')}/>
          </div>
          <div className="row">
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-nature-of-business-selector"
              options={natureOfBusinessOptions}
              title="Nature of Business"
              value={natureOfBusiness}
              placeholder=""
              onChange={select.bind(this, 'natureOfBusiness')}/>
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-assets-selector"
              options={assetsOptions}
              title="Assets"
              value={assets}
              placeholder=""
              onChange={select.bind(this, 'assets')}/>
          </div>
          <div className="row">
            <Selector
              multi
              clearable={false}
              className="reports-tab-bankruptcy-case-properties-selector"
              options={casePropertiesOptions}
              title="Case Properties"
              value={caseProperties}
              placeholder=""
              onChange={multiselect.bind(this, 'caseProperties')}/>
            <Selector
              clearable={false}
              className="reports-tab-bankruptcy-party-info-selector"
              options={partyInfoOptions}
              title="Party Info"
              value={partyInfo}
              placeholder=""
              onChange={select.bind(this, 'partyInfo')}/>
          </div>
        </FieldSet>
      </div>
    );
  }
}

Bankruptcy.propTypes = {
  region: PropTypes.any.isRequired,
  chapter: PropTypes.any.isRequired,
  caseType: PropTypes.any.isRequired,
  dateType: PropTypes.any.isRequired,
  dateFrom: PropTypes.any.isRequired,
  dateTo: PropTypes.any.isRequired,
  typeOfDebtor: PropTypes.any.isRequired,
  natureOfDebt: PropTypes.any.isRequired,
  natureOfBusiness: PropTypes.any.isRequired,
  assets: PropTypes.any.isRequired,
  caseProperties: PropTypes.any.isRequired,
  partyInfo: PropTypes.any.isRequired,
  setFormValue: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  multiselect: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(Bankruptcy);


const chapterOptions = {
  7: '7',
  9: '9',
  11: '11',
  12: '12',
  13: '13',
  15: '15',
};

const caseTypeOptions = {
  ap: 'ap',
  bk: 'bk',
  mp: 'mp',
};

const dateTypeOptions = {
  filed: 'Filed date',
  entered: 'Entered date',
  discharged: 'Discharged date',
  dismissed: 'Dismissed date',
  closed: 'Closed date',
  converted: 'Converted date',
};

const typeOfDebtorOptions = {
  i: 'individual',
  p: 'partnership',
  u: 'corporation',
  n: 'other',
};

const natureOfDebtOptions = {
  b: 'business',
  c: 'consumer / non-business',
};

const natureOfBusinessOptions = {
  b: 'clearing bank',
  c: 'commodity broker',
  h: 'health care business',
  o: 'tax-exempt entity',
  r: 'single-asset real estate',
  s: 'stockbroker',
  x: 'railroad',
  O: 'other nature of business',
};

const assetsOptions = {
  n: 'No',
  u: 'Unknown',
  y: 'Yes',
};

const casePropertiesOptions = {
  open_cases: 'Open Cases',
  closed_cases: 'Closed cases',
  voluntary: 'Voluntary',
  involuntary: 'Involuntary',
  smallbusiness: 'Small Business Cases Only',
  proseonly: 'Pro se Cases Only',
};

const partyInfoOptions = {
  '': 'No',
  yes: 'Yes',
};



/** WEBPACK FOOTER **
 ** ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/Bankruptcy/Bankruptcy.js
 **/